/* eslint-disable */
import axios from 'axios'
import { refresh, getAccessToken } from './auth'

let axiosInstance = null

export function initVerifiedAxios(baseUrl) {
  axiosInstance = axios.create({
    baseURL: baseUrl + '/api/verified_service/v1',
    timeout: 15000,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  })
  axiosInstance.interceptors.request.use(request => {
    let token = getAccessToken()
    if (token) request.headers['Authorization'] = 'Bearer ' + token
    return request
  })
  // do something globally on request response
  axiosInstance.interceptors.response.use(
    response => {
      return response
    },
    error => {
      if (error.response.status === 401) {
        refresh().then(() => {
          console.log('Successfully refreshed access!')
        })
      }
      return Promise.reject(error)
    }
  )
  return axiosInstance
}

export default axiosInstance

export function searchLicensee(query, limit = 100) {
  query.size = limit
  let token = getAccessToken()
  return axiosInstance.post('/search_licensee', removeFalsyValues(query), {
    headers: {
      Authorization: 'Bearer ' + token
    }
  })
}

function removeFalsyValues(obj) {
  let newObj = {}
  Object.keys(obj).forEach(key => {
    if (obj[key]) {
      newObj[key] = obj[key]
    }
  })
  return newObj
}



// WEBPACK FOOTER //
// ./src/verifiedapi.js